class FiftyFiftyMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.MatchContentHeight()

    // Run on resize
    window.addEventListener('resize', this.MatchContentHeight.bind(this))
  }

  MatchContentHeight () {
    const fiftyFiftyTitles = this.querySelectorAll('.sec-FiftyFifty_Title')

    let largestHeight = 0

    fiftyFiftyTitles.forEach((title) => {
      largestHeight = Math.max(largestHeight, title.offsetHeight)
    })

    fiftyFiftyTitles.forEach((title) => {
      title.style.height = `${largestHeight}px`
    })
  }
}

if (!customElements.get('fiftyfifty-media')) {
  customElements.define('fiftyfifty-media', FiftyFiftyMedia)
}
